// components/onboarding/TrainerOnboardingWelcomeModal.jsx
import React from 'react';
import { useTrainerOnboarding } from '../../context/TrainerOnboardingContext';
import { PiDog } from 'react-icons/pi';
import { FiCalendar, FiUser, FiArrowRight, FiX, FiUsers } from 'react-icons/fi';
import { MdOutlineTask, MdSchool } from 'react-icons/md';
import '../../styles/Onboarding.css';

/**
 * TrainerOnboardingWelcomeModal
 *
 * Initial modal shown to first-time trainer users asking if they want
 * to take a guided tour of the application.
 */
const TrainerOnboardingWelcomeModal = () => {
    const { showWelcomeModal, startOnboarding, skipOnboarding } = useTrainerOnboarding();

    if (!showWelcomeModal) {
        return null;
    }

    return (
        <div className="onboarding-modal-overlay">
            <div className="onboarding-welcome-modal">
                {/* Close button */}
                <button
                    className="onboarding-close-btn"
                    onClick={skipOnboarding}
                    title="Zamknij"
                    aria-label="Zamknij"
                >
                    <FiX />
                </button>

                {/* Header */}
                <div className="onboarding-welcome-header">
                    <div className="onboarding-welcome-icon">
                        <MdSchool />
                    </div>
                    <h2>Witaj w PetBoard!</h2>
                    <p className="onboarding-welcome-subtitle">
                        Panel trenera - wszystko czego potrzebujesz
                    </p>
                </div>

                {/* Body */}
                <div className="onboarding-welcome-body">
                    <p className="onboarding-welcome-message">
                        Czy chcesz zobaczyć krótki przewodnik po aplikacji?
                        Pokażemy Ci najważniejsze funkcje w kilku prostych krokach.
                    </p>

                    <div className="onboarding-features-preview">
                        <h4>Co poznasz:</h4>
                        <ul>
                            <li>
                                <span className="feature-icon"><PiDog /></span>
                                <span>Zarządzanie podopiecznymi</span>
                            </li>
                            <li>
                                <span className="feature-icon"><FiUsers /></span>
                                <span>Listę wlaścicieli i zaproszenia</span>
                            </li>
                            <li>
                                <span className="feature-icon"><MdOutlineTask /></span>
                                <span>Ćwiczenia i raporty</span>
                            </li>
                            <li>
                                <span className="feature-icon"><FiCalendar /></span>
                                <span>Kalendarz i treningi</span>
                            </li>
                            <li>
                                <span className="feature-icon"><FiUser /></span>
                                <span>Ustawienia konta i godzin pracy</span>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Actions */}
                <div className="onboarding-welcome-actions">
                    <button
                        className="onboarding-btn onboarding-btn-primary"
                        onClick={startOnboarding}
                    >
                        Rozpocznij przewodnik
                        <FiArrowRight />
                    </button>
                    <button
                        className="onboarding-btn onboarding-btn-secondary"
                        onClick={skipOnboarding}
                    >
                        Pomiń, znam już aplikację
                    </button>
                </div>

                {/* Footer note */}
                <p className="onboarding-welcome-footer">
                    Możesz zawsze wrócić do tego przewodnika później w zakładce Moje konto.
                </p>
            </div>
        </div>
    );
};

export default TrainerOnboardingWelcomeModal;
